<template>
  <SideBlock class="TableOfContents" :title="$t('toc.title')">
    <ul>
      <li v-for="(heading, index) in headings" :key="index">
        <a
          :href="`#${$helpers.stringToSlug(heading)}`"
          class="flex items-center gap-2"
        >
          <IconComponent icon="arrow-right" class="inline" />
          {{ heading }}
        </a>
      </li>
    </ul>
  </SideBlock>
</template>

<script>
import SideBlock from "~/components/_refactored/mainpage/SideBlock.vue";
export default {
  components: { SideBlock },
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  computed: {
    headings() {
      return (this.content ?? "")
        .split("\n")
        .filter((row) => row.startsWith("## "))
        .map((heading) => heading.split("## ")[1]);
    },
  },
};
</script>
